@if (label) {
    <label class="ui-switch-manager__label">{{label}}</label>
}

@for (item of itemsArray; track item.value) {
    <span
        class="ui-switch-manager__item"
        (click)="onSelectItem(item.value)"
    >
        <span
            class="radio-circle {{selectedItem === item.value ? 'checked' : ''}}"
        ></span>

        {{ item.label }}
    </span>
}
